import React from "react";
import Stage1 from "./stage-1";
import Stage2 from "./stage-2";
import Stage3 from "./stage-3";
import Stage4 from "./stage-4";
import Stage5 from "./stage-5";
import Stage6 from "./stage-6";

const Order = React.lazy(() => import("./order"));
const Profile = React.lazy(() => import("./profile"));
const Holdings = React.lazy(() => import("./holdings"));
const InvestmentBasket = React.lazy(() => import("./investment-basket"));
const InvestmentGoals = React.lazy(() => import("./investment-goals"));
const IndvidualInvestment = React.lazy(() => import("./individual-investment"));
const AllSip = React.lazy(() => import("./all-sip"));
const ExternalInvestmentImport = React.lazy(() => import("./external-import"));

export {
  ExternalInvestmentImport,
  Stage1,
  Stage2,
  Stage3,
  Stage4,
  Stage5,
  Stage6,
  Order,
  AllSip,
  Holdings,
  IndvidualInvestment,
  Profile,
  InvestmentBasket,
  InvestmentGoals,
};
